define(["require", "exports", "@lit/context"], function (require, exports, context_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.applicationContext = void 0;
    exports.applicationContext = (0, context_1.createContext)('application');
});
